import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/the-pips-insights-contents/TopicOne";

const ThePipsInsightsContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Market Intelligence, Simplified</h2>
                <p>
                  The Pips Insights is your go-to source for data-driven
                  perspectives on global markets. Our team of analysts breaks
                  down complex economic trends, trading signals, and asset
                  movements into actionable insights you can actually use.
                  Whether you’re investing long-term or day trading, The Pips
                  Insights helps you make every move with confidence and
                  clarity. Each update is crafted to highlight what truly
                  matters, filtering out the noise and focusing on high-impact
                  information. With insights tailored to real trading
                  conditions, you stay informed, prepared, and ahead of market
                  shifts.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Read Latest Articles
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/the_pips_insights/resources_insights_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThePipsInsightsContentOne;
